module.exports = __webpack_public_path__ + "img/Dwerve-Crossbow-349.377a090d.gif";